<c-container class="mt-5">
  <h1>Failed Refunds</h1>
  @if (uiState === uiStateEnumForTemplate.ShowLoading) {
    <mat-spinner></mat-spinner>
  } @else if (uiState === uiStateEnumForTemplate.ShowData) {
    <app-failed-refunds-table [failedRefunds]="failedRefunds"></app-failed-refunds-table>
  }
</c-container>
